import { render, staticRenderFns } from "./DprReports.vue?vue&type=template&id=4f2511a2"
import script from "./DprReports.vue?vue&type=script&lang=js"
export * from "./DprReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports